function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.27 11.69c.48 0 .89.34.98.8l.24 1.2h3.36v-6h-4.42c-.48 0-.89-.34-.98-.8l-.24-1.2H6.85v6h6.42z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.85 13.69h4.78c.48 0 .89.34.98.8l.08.39c.09.47.5.8.98.8h5.18c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-3.78c-.48 0-.89-.34-.98-.8l-.08-.38c-.09-.47-.5-.8-.98-.8H5.85c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-6.01zm0-8h4.54c.48 0 .89.34.98.8l.08.39c.09.47.5.8.98.8h4.42v6h-3.36l-.24-1.2c-.09-.47-.5-.8-.98-.8H6.85V5.69z"
}));